<template>
  <v-text-field
      label="Damage greater than"
      outlined
      dense
      hide-details="auto"
      type="number"
      v-model="damage"
      @change="onChange"
       :error="damage < 0"
      :error-messages="damage < 0 ? 'Damage cannot be negative' : ''"
  ></v-text-field>
</template>

<script>
import { email } from "vee-validate/dist/rules";
export default {
  name: "date",
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    damage: null,
  }),
  computed: {},
  methods: {
    onChange(val) {
         if (this.damage >= 0) {
      this.$emit("input", this.damage);
         }
    },
  },
  watch: {
    clear: {
      handler(val) {

        this.damage = null;
      },
      deep: true,
    },
  },
};
</script>
